/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { ReloadCommand } from './reload.command';
import { Actions, Store } from '@ngxs/store';
import { LoggerService } from '../../../shared/services/logger.service';

export function reloadFactory() {
    const command = new ReloadCommand();
    command.setDependencies({
        store: inject(Store),
        actions$: inject(Actions),
        logger: inject(LoggerService),
    });
    return command;
}
